const WithConditionalWrapper = ({ children, condition, wrapper }) => condition ? wrapper(children) : children;
export default WithConditionalWrapper;
